<template>

  <div>
    <header class="header" style="background-color: black">
      <div class="container text-center">
        <h4 class="text-muted">Time Calculator</h4>
      </div>
    </header>

    <div class="container">

      <div class="row">
        <div class="col" style="text-align: center">
          <p style="color: gray; font-size: 0.7em; display: inline-block">
            This service is a tool that calculates clocks.<br>
            Using this service that you can know different time zones.<br>
            Please, keep mind that time zone settings you customized are stored into URL address includes location hash.<br>
            So you have to bookmark them to save your customized.<br>
          </p>
        </div>
      </div>

      <div class="row">
        <p class="col text-center" style="color: indianred">{{ error }}</p>
      </div>

      <div class="row">
        <div class="col text-center mb-3">
          <button class="btn btn-primary btn-sm m-1" @click="onClickNow">
            <i class="fa fa-refresh"></i> Now
          </button>

          <button class="btn btn-primary btn-sm m-1" @click="editMode = !editMode">
            <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
          </button>
        </div>

      </div>

      <div class="row">
        <div class="col">
          <div class="input-group input-group-sm mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text">UnixTime</span>
            </div>
            <input v-model="unixTime" type="number" maxlength="10" class="form-control"
                   v-on:keyup.enter="onClickApplyUnixTime">
            <button class="btn btn-primary btn-sm" :key="myZonesDateTimes" v-on:click="onClickApplyUnixTime">
              <i class="fa fa-chain" v-if="synced('UnixTime')"></i>
              <i class="fa fa-chain-broken" v-else></i>
            </button>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div class="row" v-if="edit">
          <div class="col input-group mb-3">
            <select class="form-control form-control-sm" v-model="selected">
              <option disabled value="">Select time zone to add</option>
              <option v-for="z in selectableZones" v-bind:key="z">{{ z }}</option>
            </select>
            <button class="input-group-append  btn btn-danger btn-sm" v-on:click="onAdd">Add</button>
          </div>
        </div>
      </transition>

      <draggable tag="div" :list="myZones" handle=".handle" @change="onDragDrop">
        <div class="row" v-for="z in myZones" :key="z" v-bind="dragOptions">

          <div class="col mb-3">
            <div class="zone-panel" style="padding: 0.7em;" :style="{backgroundImage:panelBackGround(z)}">
              <div class="handle" style="display: inline-block; color: #fffc; width: 1em">
                <i class="fa fa-ellipsis-v"></i>
                <i class="fa fa-ellipsis-v" style="margin-left: 0.1em"></i>
              </div>

              <transition name="fade">
                <div v-if="edit"
                     style="display: inline-block; padding-left: 0.5em; padding-right: 0.5em;">
                  <i class="fa fa-times-circle-o" style="color: #f00d"
                     v-on:click="onClickRemoveZone(z)"></i>
                </div>
              </transition>

              <span style="color: whitesmoke; text-shadow: black 1px 1px 2px">{{ z }}</span>

              <div class="input-group input-group-sm mt-1" style="padding-left: 1em; opacity: 0.9">
                <input type="text" v-model.lazy="myZonesDateTimes[z]"
                       class="form-control"
                       v-on:keyup.enter="onClickApplyZoneTime(z)">

                <button class="btn btn-primary btn-sm" type="button"
                        v-on:click="onClickApplyZoneTime(z)">
                  <i class="fa fa-chain" v-if="synced(z)"></i>
                  <i class="fa fa-chain-broken" v-else></i>
                </button>
              </div>

            </div>
          </div>
        </div>
      </draggable>

    </div>

    <footer class="footer">
      <div class="container text-center">
        <p class="text-muted">© 2020 tyablog.net</p>
      </div>
    </footer>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import jstz from 'jstimezonedetect';
import {VueDraggableNext} from 'vue-draggable-next';
import ZoneStore from "@/components/ZoneStore";
import BackgroundStore from "@/components/BackgroundStore";
import SyncStore from "@/components/SyncStore";

/**
 *
 * @type {ZoneStore}
 */
let zoneStore = null;

let backgroundStore = new BackgroundStore(
    "/images/bg_morning.jpg",
    "/images/bg_day.jpg",
    "/images/bg_afternoon.jpg",
    "/images/bg_night.jpg");

let syncStore = new SyncStore();

export default {
  name: 'TimeZoneSelector',
  components: {
    draggable: VueDraggableNext,
  },
  props: {},

  data() {
    return {
      error: '',
      unixTime: '',
      browserZoneName: jstz.determine().name(),

      /**
       * @type {boolean}
       */
      editMode: false,

      /**
       * @type {[String]}
       */
      myZones: [],

      /**
       * @type {{String:String}}
       */
      myZonesDateTimes: {},

      /**
       * 有効なタイムゾーン名、Vueコンポーネント作成時にサーバーから一覧を取得して設定する。
       * この一覧にあるタイムゾーン以外は設定できない。
       *
       * @type {[String]}
       */
      selectableZones: [],

      /**
       * タイムゾーン追加枠の選択中のもの。
       *
       * @type {String}
       */
      selected: "",

      /**
       * Vueコンポーネントの初期化処理が終わっているかどうか。
       *
       * @type {boolean}
       */
      initialized: false
    }
  },

  created() {
    axios.get('/api/time_zones')
        .then(response => {
          this.selectableZones = response.data.zones;
        })
        .then(() => {
          zoneStore = new ZoneStore(this.selectableZones);
          this.myZones = zoneStore.load();

          this.onClickNow();

          this.initialized = true;
        })
  },

  computed: {
    dragOptions() {
      return {}
    },
    edit() {
      if (!this.initialized) return false;

      return this.editMode || 0 === this.myZones.length;
    }
  },


  methods: {
    onAdd() {
      if (this.selected === "") return;
      if (this.myZones.some(x => x === this.selected)) return;

      console.log("add: " + this.selected);
      this.myZones.push(this.selected)

      zoneStore.save(this.myZones)
    },

    /**
     * 時刻によって背景画像を変更
     * @param z {String}
     * @returns {String}
     */
    panelBackGround(z) {
      let t = this.myZonesDateTimes[z];
      return backgroundStore.getBackground(z, t)
    },

    /**
     * 指定タイムゾーンが、他と同期されているか
     * @param z {String}
     * @returns {Boolean}
     */
    synced(z) {
      if ("UnixTime" === z) {
        return syncStore.synced(z, this.unixTime);
      }

      let t = this.myZonesDateTimes[z];
      return syncStore.synced(z, t);
    },

    onClickRemoveZone(name) {
      if (!confirm("Will you remove this timezone: '" + name + "'?")) {
        return;
      }

      let idx = this.myZones.indexOf(name)
      this.myZones.splice(idx, 1);

      zoneStore.save(this.myZones)
    },

    onClickApplyUnixTime() {
      let params = {
        unixTime: this.unixTime,
        browserZoneOffset: new Date().getTimezoneOffset(),
        browserZoneName: this.browserZoneName,
        myZones: this.myZones,
      };

      axios.get("/api/conv_unixtime_into_utc", {params: params})
          .then(res => {
            this.updateFromResponse(res);
          })
          .catch(err => {
            console.log(err);
          });
    },
    onClickApplyZoneTime(name) {
      let params = {
        strDateTime: this.myZonesDateTimes[name],
        zoneName: name,
        myZones: this.myZones,
      };

      axios.get("/api/conv_str_into_utc", {params: params})
          .then(res => {
            this.updateFromResponse(res);
          })
          .catch(err => {
            console.log(err);
          });
    },

    updateFromResponse(res) {
      console.log(res);

      if (res.data.error) {
        console.log(res.data.error);
        this.error = res.data.error;
        return;
      }

      this.error = "";
      this.unixTime = "" + res.data.unixTime;
      this.myZonesDateTimes = res.data.zonedDateTimes;

      let m = new Map();
      m.set("UnixTime", this.unixTime);
      for (const [key, value] of Object.entries(this.myZonesDateTimes)) {
        m.set(key, value);
      }

      syncStore.sync(m);
    },

    /**
     * @param list {[*]}
     * @param from {Number}
     * @param to {Number}
     */
    arrayMove(list, from, to) {
      const elm = list.splice(from, 1)[0];
      list.splice(to, 0, elm);
    },

    onDragDrop() {
      zoneStore.save(this.myZones)
    },

    onClickNow() {
      this.unixTime = "" + Math.floor(Date.now() / 1000);
      this.onClickApplyUnixTime()
    },
  }
}
</script>


<style scoped>

.fade-enter-active {
  transition: .3s;
}

.fade-leave-active {
  transition: .6s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.zone-panel {
  border: solid 1px gray;
  border-radius: 0.3em;
  box-shadow: 2px 2px 4px;
  background-size: cover;
  background-color: slategray;
}

.handle:hover {
  cursor: grab;
}

</style>
